import createLucideIcon from '../createLucideIcon';

const HelpCircle = createLucideIcon('HelpCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3', key: '1u773s' }],
  ['line', { x1: '12', y1: '17', x2: '12.01', y2: '17', key: 'kdstpg' }],
]);

export default HelpCircle;
